import { PageSection, PageWrapper } from '@src/components';

export function ReferralRules() {
  return (
    <PageWrapper rootClassName='space-y-6 text-wl-on-background my-4'>
      <div className='space-y-2'>
        <p className='text-B-16'>1. One account per user is allowed.</p>
        <p className='text-M-16'>
          Creating multiple accounts to abuse the referral system will result in
          all related accounts being suspended and referral rewards voided.
        </p>
      </div>
      <div className='space-y-2'>
        <p className='text-B-16'>2. Self-referrals are strictly prohibited.</p>
        <p className='text-M-16'>
          Referring yourself or creating new accounts for family or friends
          using the same device or internet connection is considered fraud.
        </p>
      </div>
      <div className='space-y-2'>
        <p className='text-B-16'>3. Referred users must be real and active</p>
        <p className='text-M-16'>
          Referral rewards are only granted when the invited user makes a valid
          purchase or meaningful use of Esimora services. Simply signing up is
          not enough.
        </p>
      </div>
      <div className='space-y-2'>
        <p className='text-B-16'>
          4. A minimum of 3 successful referrals is required to be eligible for
          payout.
        </p>
        <p className='text-M-16'>
          Users must invite at least 3 different individuals who meet the
          referral conditions (such as making a valid purchase) in order to
          qualify for a withdrawal.
        </p>
      </div>
      <div className='space-y-2'>
        <p className='text-B-16'>
          5. The referral reward balance must reach the minimum threshold before
          it can be withdrawn.
        </p>
        <p className='text-M-16'>
          Even if the number of referrals is met, the total reward amount must
          reach the defined minimum to be eligible for settlement or withdrawal.
        </p>
      </div>
      <div className='space-y-2'>
        <p className='text-B-16'>
          6. Esimora reserves the right to monitor and investigate suspicious
          activity.
        </p>
        <p className='text-M-16'>
          Any behavior such as rapid sign-ups, use of VPNs/proxies, or unusual
          patterns may lead to temporary account suspension and review.
        </p>
      </div>
      <PageSection className='bg-wl-background text-B-16 px-4 py-2'>
        Any attempt to bypass these rules will result in account suspension and
        loss of all referral benefits.
      </PageSection>
    </PageWrapper>
  );
}
